module.exports = __webpack_public_path__ + "media/img/home/img_corporate-seminar-4afe4a1b370f398e41ce14f527dbfb57.png";